export default function HowLandLodWorks() {
  const steps = [
    {
      title: "Create Your Account",
      description: "Sign up with your details and mobile money payout method.",
    },
    {
      title: "List Properties & Tenants",
      description:
        "Add properties, configure units, and assign tenants with rent rates.",
    },
    {
      title: "Share Payment Codes",
      description:
        "Tenafix generates a unique code per tenant. Share this with them for payment access.",
    },
    {
      title: "Collect Rent & Track Activity",
      description:
        "Monitor who paid, what’s overdue, and how your properties are performing — all in real time.",
    },
    {
      title: "Receive Payouts Automatically",
      description:
        "Funds are transferred directly to your account, minus platform commission and fees.",
    },
  ];

  return (
    <div className="flex flex-col items-center md:block w-11/12 xl:w-full md:mx-auto xl:px-[120px]  ">
      <div className="flex flex-col justify-between items-center lg:flex-row gap-0 lg:gap-8 w-full mb-[67px]">
        <div
          className="font-alexandria font-semibold text-primary-text 
            lg:text-4xl lg:leading-[130%] lg:tracking-[0%] lg:mb-9
            xl:text-[46px] xl:leading-[130%] xl:tracking-[0%] xl:mb-9
            md:text-4xl text-[1.50rem] xs:text-[1.60rem] leading-[130%] tracking-[0%] mb-9 px-2 md:p-0 flex flex-col items-center lg:block"
        >
          <div className="xl:w-[90px] xl:h-[9px] xl:ml-3 xl:mb-[23px]lg:w-[75px] lg:h-[8px] lg:ml-3 lg:mb-[20px] w-[75px] h-[8px] ml-3 mb-[35px] bg-gradient-blue" />
          <h1 className="flex flex-col items-center lg:items-start ">
            <span className="block text-start">How Tenafix</span>
            <span className="block">Works</span>
          </h1>
        </div>
        <p className="text-[#494949] md:w-full lg:w-3/5 xl:w-full font-poppins font-medium text-center lg:text-left text-[16px] leading-[31px] tracking-[0] md:text-[18px] lg:max-w-xl px-10 lg:p-0">
          Tenafix makes property management simple: create your account, list
          properties and tenants, share unique payment codes, track payments in
          real time, and receive automatic payouts to your account.
        </p>
      </div>

      <div className="relative">
        {/* Mobile vertical dashed line */}
        <div className="absolute left-0 ml-[38px] top-[720px] [@media(min-width:404px)]:top-[720px]  sm:top-[720px] bottom-0 w-0.5 -translate-y-1/2 h-[1200px] [@media(min-width:362px)]:h-[1200px] [@media(min-width:404px)]:h-[1200px]  sm:h-[1200px] md:hidden border-l-2 border-dashed border-[#2387C0] z-0" />
        {/* Desktop horizontal dashed line */}
        <div className="hidden md:block absolute top-[42px] inset-x-[90px] border-t-2 border-dashed border-[#2387C0] z-0" />

        {/* Steps */}
        <div className="flex flex-col md:flex-row md:space-x-6 space-y-10 md:space-y-0">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-row md:flex-col gap-6 sm:gap-12 justify-start items-center min-h-[16.25rem] flex-1 relative z-10"
            >
              {/* Numbered Circle */}
              <div className="mb-[27px] bg-[#2387C0] text-white border-[9px] border-[#aedcf7aa] text-center rounded-full w-[75px] h-[75px] flex items-center font-alexandria justify-center shadow-md text-[46px] font-semibold ">
                {index + 1}
              </div>

              {/* Card */}
              <div className="bg-[#CFADFB1C] font-poppins rounded-[10px] py-[1.75rem] px-[0.75rem] shadow-sm w-[60%] sm:w-[100%] max-w-[221px] md:max-w-full text-start  h-full">
                <h4 className="font-semibold text-[#242527] text-[1rem] sm:text-[1.125rem] font-poppins md:text-[14px] leading-[1.875rem] lg:text-lg xl:text-xl  mb-[1.25rem]">
                  {step.title}
                </h4>
                <p className="text-[#494949] leading-[1.4375rem] text-[0.75rem] sm:text-[0.9375rem]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
